export default {"src":"/_next/static/media/college9.0fe39b32.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};